var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tabs', {
    attrs: {
      "hide-slider": "",
      "value": _vm.value
    },
    on: {
      "change": function (v) {
        return _vm.$emit('input', v);
      }
    }
  }, [_c('v-tab', [_vm._v("Input spec")]), _c('v-tab', [_vm._v("Project input data")]), _c('v-tab', [_vm._v("Builder resources")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }